export default __webpack_public_path__ + "static/media/atb.9a062211.png";